import { render } from "./TemplatesTable.vue?vue&type=template&id=527245b1&scoped=true"
import script from "./TemplatesTable.vue?vue&type=script&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&lang=js"

import "./TemplatesTable.vue?vue&type=style&index=0&id=527245b1&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527245b1"]])

export default __exports__